import FullStackImg from '../assets/FullStack.jpg';
import FrontendImg from '../assets/Frontend.jpg';
import BackendImg from '../assets/Backend.jpg';

const imageMap = {
    fullstack: FullStackImg,
    frontend: FrontendImg,
    backend: BackendImg,
};

const ServiceCard = ({ item, className = "" }) => {
    const { icon, title, services, skills } = item;

    return (
        <div className={`card card-two group relative border border-[rgba(0,0,0,0.05)] dark:border-[rgba(255,255,255,0.05)] hover:border-primary/50 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 w-full mx-auto lg:mx-0 max-w-[550px] flex flex-col overflow-hidden text-left ${className}`}>
            {/* Subtle Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

            {/* Header */}
            <div className="relative z-10 flex items-center gap-4 mb-5">
                <div className="w-14 h-14 min-w-[56px] rounded-xl overflow-hidden group-hover:scale-105 transition-transform duration-300 shadow-sm">
                    <img src={imageMap[icon]} alt={title} className="w-full h-full object-cover" />
                </div>
                <h3 className="text-lg font-bold font-title tracking-wide text-title group-hover:text-primary transition-colors duration-300 leading-snug">{title}</h3>
            </div>

            {/* Services List */}
            <ul className="relative z-10 flex flex-col gap-2.5 mb-3 flex-grow">
                {services.map((service, index) => (
                    <li key={index} className="flex items-start gap-2.5 text-normal opacity-90 text-[0.85rem] leading-relaxed group-hover:opacity-100 transition-opacity">
                        <span className="w-1.5 h-1.5 rounded-full bg-primary mt-1.5 min-w-[6px]"></span>
                        {service}
                    </li>
                ))}
            </ul>

            {/* Skills Tags */}
            <div className="relative z-10 flex flex-wrap gap-2 mt-auto pt-4 border-t border-white/10 [.light-theme_&]:border-black/5">
                {skills.map((skill, index) => (
                    <span
                        key={index}
                        className="px-2.5 py-1 text-[0.8rem] font-medium tracking-wide bg-white/5 border border-white/10 text-white/90 [.light-theme_&]:bg-black/5 [.light-theme_&]:border-black/5 [.light-theme_&]:text-black/80 rounded-lg group-hover:border-primary/20 transition-colors"
                    >
                        {skill}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default ServiceCard;